import { render, staticRenderFns } from "./WalletCardStyle.vue?vue&type=template&id=6bc1b782&scoped=true&"
import script from "./WalletCardStyle.vue?vue&type=script&lang=js&"
export * from "./WalletCardStyle.vue?vue&type=script&lang=js&"
import style0 from "./WalletCardStyle.vue?vue&type=style&index=0&id=6bc1b782&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc1b782",
  null
  
)

export default component.exports